var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
class Leaf {
  constructor(factory, ComponentType) {
    __publicField(this, "specification");
    if (typeof factory === "function") {
      this.specification = {
        type: "useSite",
        ComponentType,
        factory
      };
    } else {
      this.specification = {
        type: "declarationSite",
        factoryMethodName: factory
      };
    }
  }
}
export {
  Leaf
};
//# sourceMappingURL=Leaf.js.map
